module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('label', [_vm._v(" Name * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProblem.name),
      expression: "newProblem.name"
    }],
    ref: "inputProblemName",
    attrs: {
      "autofocus": ""
    },
    domProps: {
      "value": _vm._s(_vm.newProblem.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newProblem.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(" Url * ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProblem.url),
      expression: "newProblem.url"
    }],
    domProps: {
      "value": _vm._s(_vm.newProblem.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newProblem.url = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v(" Notes ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProblem.notes),
      expression: "newProblem.notes"
    }],
    domProps: {
      "value": _vm._s(_vm.newProblem.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newProblem.notes = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.toEdit) ? _c('button', {
    on: {
      "click": _vm.doneEdit
    }
  }, [_vm._v("\n    Edit !\n  ")]) : _c('button', {
    on: {
      "click": _vm.addProblem
    }
  }, [_vm._v("\n    Add !\n  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.desc)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7309b6ee!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProblemForm.vue
// module id = 53
// module chunks = 2